/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import {
  Grid,
  GridItem,
  Heading,
  Link,
  Main,
  Paragraph,
  Strong,
} from '@constellation/core';
import { useContent } from '@interstellar/react-app-content';
import clipboard from 'assets/common/clipboard.png';
import GradientBox from 'client/components/gradientBox/GradientBox';
import MetaTags from 'client/components/metaTags/MetaTags';
import RedGradientBox from 'client/components/redGradientBox/RedGradientBox';
import { logTealiumButtonClickEvent } from 'client/tealium';
import testIds from 'client/testIds';

import ApplicationSection from './components/ApplicationSection';
import CompanySection from './components/CompanySection';
import CustomerSection from './components/CustomerSection';
import ExistingCustomerSection from './components/ExistingCustomerSection';
import IncomeSection from './components/IncomeSection';
import LendingSection from './components/LendingSection';
import PropertySection from './components/PropertySection';
import { LimitedCompanyCriteriaContent } from './LimitedCompanyCriteria.config';

function LimitedCompanyCriteriaPage(): React.JSX.Element {
  const { metaContent, pageTitle, introText, jumpToASection } =
    useContent<LimitedCompanyCriteriaContent>();

  return (
    <Main>
      <MetaTags metaContent={metaContent} />

      <GradientBox>
        <RedGradientBox
          imgSrc={clipboard}
          imgAlt="Icon of a notepad with a checklist"
        >
          <Heading
            as="h1"
            size="s7"
            marginBottom="03"
            data-testid={testIds.limitedCompanyCriteria.heading}
            inverse
          >
            {pageTitle}
          </Heading>
          <Paragraph>
            <Strong inverse>{introText}</Strong>
          </Paragraph>
        </RedGradientBox>
      </GradientBox>

      <section id="jump-to-a-section" data-testid="jump-to-a-section">
        <Heading size="s5" marginBottom="05" as="h2" id={jumpToASection.id}>
          {jumpToASection.title}
        </Heading>
        <Grid>
          {jumpToASection.links.map((linkItem) => (
            <GridItem sm={6} md={4} lg={4} key={linkItem.label}>
              <Paragraph size="s2" marginBottom="02">
                <Link
                  weight="bold"
                  href={`#${linkItem.url}`}
                  onClick={() => {
                    logTealiumButtonClickEvent({
                      label: `link/${linkItem.label}`,
                    });
                  }}
                >
                  {linkItem.label}
                </Link>
              </Paragraph>
            </GridItem>
          ))}
        </Grid>
      </section>

      <CompanySection />
      <ApplicationSection />
      <CustomerSection />
      <IncomeSection />
      <LendingSection />
      <PropertySection />
      <ExistingCustomerSection />
    </Main>
  );
}

export default LimitedCompanyCriteriaPage;
